module.exports = __webpack_public_path__ + "img/gunLeft.82b67dfa.svg";